var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLedDigit = function SvgLedDigit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      "--a": "#ff4a00",
      "--b": "#ff4a00",
      "--c": "#ff4a00",
      "--d": "#ff4a00",
      "--e": "#ff4a00",
      "--f": "#ff4a00",
      "--g": "#ff4a00"
    },
    viewBox: "0 0 535.156 894.135"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h535.16v894.14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--a)",
    fillRule: "evenodd",
    d: "M178.52 60s-30.59 5.557-44.18 12.621c-12.6 6.555-33.13 26.824-33.13 26.824l104.14 48.915 145.16-1.58 55.22-80.469z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--b)",
    fillRule: "evenodd",
    d: "m427.82 77.355-58.38 86.785-9.47 219.32 80.47 53.64 20.52-20.51 14.2-277.7s-7.29-24.26-17.63-36.46c-6.8-8.03-29.71-25.075-29.71-25.075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--f)",
    fillRule: "evenodd",
    d: "M83.85 123.12 64.918 413.44l28.619 17.57 75.519-45.97 14.2-216.17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--g)",
    fillRule: "evenodd",
    d: "m192.3 400.81-83.62 50.49 69.42 34.72 157.79 7.88 92.68-33.54-87.92-58.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--e)",
    fillRule: "evenodd",
    d: "m91.8 474.19-26.221 18.4-5.578 287.85 100.97-47.97 8.92-220.35z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c)",
    fillRule: "evenodd",
    d: "m451.49 478.12-97.83 34.72-7.89 225.63 52.07 83.62s31.57-18.32 41.03-33.13c9.33-14.63 12.62-50.49 12.62-50.49l11.04-244.57z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--d)",
    fillRule: "evenodd",
    d: "m324.48 753.09-148.59.5-101.57 49.03c.002 0 17.693 15.28 28 20.54 9.68 4.94 31.04 9.98 31.04 9.98l243.15.99z"
  })));
};
export default SvgLedDigit;